import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant utilitaire à monter à l'intérieur du Router.
 * Remet le scroll en haut à chaque changement de route OU de hash significatif.
 * Si l'URL contient un hash (#section), on laisse l'ancrage natif gérer.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // ancrage HTML natif (#xxx)
    // microtask + smooth pour permettre au DOM d'être posé
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
